var ua = navigator.userAgent;
var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
  isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
  isAndroid = ua.match(/(Android)\s+([\d.]+)/),
  isMobile = isIphone || isAndroid || ipad,
  href = window.location.href,
  hostArr = window.location.host.split('.');
hostArr[0] = ''
var host = hostArr.join('.')
var pathName = window.location.pathname
var query = window.location.search
// console.log(query)
if (!isMobile) {
  if (href.indexOf('app.nova-x.ca') != -1) {
    if (pathName == '/download' || pathName == '/register') {
      window.location.href = `https://dev.nova-x.ca${pathName}${query}`
    } else {
      window.location.href = 'https://dev.nova-x.ca'
    }
  } else {
    if (pathName == '/download' || pathName == '/register') {
      window.location.href = `https://www.superex.com${pathName}${query}`
    } else {
      window.location.href = 'https://www.superex.com'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/isMobile.js